import { IconBox, IconProps } from '@summer/jst-react-icon';

export const Edit = (props: Omit<IconProps, 'ref'>) => (
  <IconBox {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m49.324 4.57 10.607 10.606-7.778 7.778-10.607-10.607 7.778-7.778ZM38.132 15.761l10.606 10.606-31.628 31.63-9.85-.758-.757-9.85 31.629-31.628Zm0 5.657-27.5 27.5.354 4.595 4.596.354 27.5-27.5-4.95-4.95Z"
    />
  </IconBox>
);
